import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  getAppWindowHeading,
  hideAppWindow,
  isInAppWindow,
} from "../../utils/appWindowUtils";

/*
 * Projects the overlay title and Exit Full Screen into Shopify's App Window
 * top bar. The Admin X still stays; this is an extra title-bar action.
 */
const AppWindowPageHeading = () => {
  const location = useLocation();
  const exitButtonRef = useRef(null);

  useEffect(() => {
    const el = exitButtonRef.current;
    if (!el) {
      return undefined;
    }
    const onClick = () => {
      hideAppWindow();
    };
    el.addEventListener("click", onClick);
    return () => {
      el.removeEventListener("click", onClick);
    };
  }, [location.pathname]);

  if (!isInAppWindow()) {
    return null;
  }

  return (
    <s-page heading={getAppWindowHeading(location.pathname)}>
      <s-button
        ref={exitButtonRef}
        slot="primary-action"
        variant="secondary"
        icon="minimize"
      >
        Exit Full Screen
      </s-button>
    </s-page>
  );
};

export default AppWindowPageHeading;
